import React, { useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { QrCode } from '@common/components/qrCode';
import { usePrevious } from '@common/hooks/previous';
import { PopupContext } from '@app/dev/contexts/popup';
import ToastWrapper from '@common/helpers/toastWrapper';
import { useTranslation } from '@common/hooks/translation';
import { useBalance } from '@app/dev/terminal/hooks/balance';
import { OctoOperationsEnum } from '@app/dev/constants/enums/octoOperations';
import { OctoAmountTypesEnum } from '@app/dev/constants/enums/octoAmountTypes';
import { TerminalDepositModesEnum } from '@app/dev/constants/enums/terminalDepositModes';
import { setLastMoneyInputType, setTerminalDepositMode } from '@app/dev/actions/terminal';

import './styles.scss';
import { getOktoQrData } from './service';

export const CashoutOctopay = () => {
  const t = useTranslation();
  const balance = useBalance();
  const dispatch = useDispatch();
  const previousBalance = usePrevious(balance);
  const [{ closePopup }] = useContext(PopupContext);
  const terminalDepositMode = useSelector((state) => state.terminal.depositMode);

  const depositQrData = useMemo(
    () => getOktoQrData(OctoAmountTypesEnum.Dyanmic, OctoOperationsEnum.Payout, balance),
    [balance],
  );

  useEffect(() => {
    if (balance < previousBalance) {
      dispatch(setTerminalDepositMode(TerminalDepositModesEnum.Ticket));
      dispatch(setLastMoneyInputType(TerminalDepositModesEnum.Ticket));

      ToastWrapper('success', 'Cashout was successfully done!');
      closePopup();
    }
  }, [balance, previousBalance, dispatch, terminalDepositMode, closePopup]);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Cash out')}</h3>
      <div className="popup-main-content okto-popup-content">
        <p className="text-center">{t('To make your cash out, simply scan the qr code using your Okto pay app')}</p>
        <QrCode data={depositQrData} />
      </div>
      <div className="popup-actions">
        <button onClick={closePopup} className="popup-cancel-button">{t('Cancel')}</button>
      </div>
    </div>
  );
};

